<!--
  drag组件实现了拖动功能（遥控）
  使用方法：
    import Drag from '../../common/drag/drag' // 拖动组件
    <Drag>
      // 这里是需要拖动的元素 子元素有且只有一个
      <div id='drager'></div>
    </Drag>
-->
<template>
  <div class="drag-wrap" ref="dragerWrap">
    <slot @touchstart.capture="touchStart($event)"
          @touchmove.capture="touchMove($event)"
          @touchend.capture="touchEnd($event)"></slot>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    initPosition: {
      type: Object,
      default: () => ({
        left: '80vw',
        top: '66vh',
      }),
    },
    moverange: {
      type: Object,
      default: () => ({
        left: 10,
        top: '',
        bottom: '',
        right: '',
      }),
    },
    horizontalLock: Boolean,
    verticalLock: Boolean,
  },
  computed: {
    ...mapState({
      dragDisableArea: (state) => state.dragDisableArea,
    }),
  },
  data() {
    return {
      dragX: 0,
      dragY: 0,
      dragL: 0,
      dragT: 0,
      isDown: false,
      drager: null,
    };
  },
  methods: {
    touchStart(e) {
      e.preventDefault();
      if (this.drager) {
        // 获取x坐标和y坐标
        this.dragX = e.changedTouches[0].clientX;
        this.dragY = e.changedTouches[0].clientY;
        // 获取左部和顶部的偏移量
        this.dragL = this.drager.offsetLeft;
        this.dragT = this.drager.offsetTop;
        // 开关打开
        this.isDown = true;
      }
    },
    touchMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      if (this.drager) {
        const maxX = this.moverange.right ? this.moverange.right : window.innerWidth - this.drager.offsetWidth - 30;
        const minY = window.innerHeight * (this.moverange.top ? this.moverange.top : 0.1);
        const maxY = window.innerHeight * (this.moverange.bottom ? this.moverange.bottom : 0.82);
        if (this.isDown === false) {
          return;
        }
        // 获取x和y
        const nx = e.changedTouches[0].clientX;
        const ny = e.changedTouches[0].clientY;
        // 计算移动后的左偏移量和顶部的偏移量
        let nl = nx - (this.dragX - this.dragL);
        let nt = ny - (this.dragY - this.dragT);
        // 临界点
        if (nt <= minY) {
          nt = minY;
        }
        if (nt >= maxY) {
          nt = maxY;
        }
        if (nl >= maxX) {
          nl = maxX;
        }
        if (nl <= this.moverange.left) {
          nl = this.moverange.left;
        }
        if (this.resetDisableArea() !== 'none') return;
        if (!this.horizontalLock) {
          this.drager.style.left = `${nl}px`;
        }
        if (!this.verticalLock) {
          this.drager.style.top = `${nt}px`;
        }
      }
    },
    touchEnd(e) {
      e.preventDefault();
      if (Math.abs(e.changedTouches[0].clientY - this.dragY) < 2) {
        this.$emit('handleDragClick', e);
      }
      this.isDown = false;
    },
    resetDisableArea() { // 如果遥控进入禁止拖拽区，就重置left和top
      let nl = 0;
      let nt = 0;
      const clientRect = this.drager.getBoundingClientRect();
      if (this.dragDisableArea && (clientRect.x + clientRect.width) > this.dragDisableArea.x && (clientRect.y + clientRect.height) > this.dragDisableArea.y) {
        nl = this.dragDisableArea.x - clientRect.width - 1;
        nt = this.dragDisableArea.y - clientRect.height - 1;
        this.isDown = false;
        if (!this.horizontalLock) {
          this.drager.style.left = `${nl}px`;
        }
        if (!this.verticalLock) {
          this.drager.style.top = `${nt}px`;
        }
      } else {
        return 'none';
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drager = this.$refs.dragerWrap && this.$refs.dragerWrap.childNodes[0];
      if (this.drager) {
        this.drager.addEventListener('touchstart', this.touchStart);
        this.drager.addEventListener('touchmove', this.touchMove);
        this.drager.addEventListener('touchend', this.touchEnd);
        this.drager.style.left = this.initPosition.left;
        this.drager.style.top = this.initPosition.top;
      }
    });
  },
  watch: {
    dragDisableArea(newVal) {
      if (newVal && newVal.x) {
        this.resetDisableArea();
      }
    },
  },
};
</script>
